import { render, staticRenderFns } from "./AccountDashboard.vue?vue&type=template&id=83cbd69e&scoped=true&"
import script from "./AccountDashboard.vue?vue&type=script&lang=js&"
export * from "./AccountDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AccountDashboard.vue?vue&type=style&index=0&id=83cbd69e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cbd69e",
  null
  
)

component.options.__file = "AccountDashboard.vue"
export default component.exports